import {Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip} from "recharts";
import {newReferenceFontSize} from "~/components/reports/reportConstants";
import {useAnankePreferences} from "@vesta/ananke/contexts/anankeClientContext";

export const DonutChart = ({
    data,
    baseSize,
    title,
    valuesPrefix,
    scalingFactor,
}: {
    data: Array<{name: string; value: number; color: string}>;
    title: string;
    baseSize: number;
    valuesPrefix?: string | null;
    scalingFactor: number;
}) => {
    const totalValue = data.reduce((acc, dataPoint) => (acc += dataPoint.value), 0);

    return (
        <div
            className="w-full grid place-items-center"
            style={{height: "100%"}}
        >
            {/* <div
                style={{
                    fontSize: `${newReferenceFontSize * scalingFactor}px`,
                }}
            >
                {title}
            </div> */}
            <ResponsiveContainer
                width={"100%"}
                height={baseSize}
            >
                <PieChart>
                    <Pie
                        data={data}
                        dataKey={"value"}
                        nameKey={"name"}
                        cornerRadius={2}
                        blendStroke={true}
                        stroke="#000"
                        paddingAngle={3}
                        innerRadius="65%"
                        width={baseSize - newReferenceFontSize * scalingFactor}
                        height={baseSize - newReferenceFontSize * scalingFactor}
                    >
                        {data.map((dataPoint, dataPointIndex) => (
                            <Cell
                                key={`cell-${dataPointIndex}`}
                                fill={dataPoint.color}
                                className="focus:!outline-none"
                            />
                        ))}
                    </Pie>

                    <Legend
                        verticalAlign="bottom"
                        align="center"
                        wrapperStyle={{
                            bottom: "-4px",
                            fontSize: "10px",
                            maxHeight: "30%",
                            overflowY: "auto",
                            overflowX: "clip",
                            color: "#fff",
                        }}
                    />

                    <Tooltip
                        content={
                            <CustomTooltip
                                prefix={valuesPrefix}
                                totalValue={totalValue}
                            />
                        }
                    />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
};

export function CustomTooltip({active, payload, prefix, totalValue}) {
    const {theme} = useAnankePreferences();
    if (active !== null && active !== undefined && payload !== null && payload !== undefined && Array.isArray(payload) === true && payload[0] !== undefined) {
        return (
            <div
                className="custom-tooltip"
                style={{
                    color: theme === "dark" ? "#C7C7C7" : "#292a2e",
                    background: theme === "dark" ? "#1F1F1F" : "#ffffff",
                    border: theme === "dark" ? "1px solid #383838" : "1px solid #0b120e24",
                    borderRadius: "4px",
                    fontSize: "14px",
                    padding: "12px 12px",
                }}
            >
                <div style={{color: payload[0]?.payload?.color}}>
                    {`${payload[0].name} : ${prefix !== null ? prefix : ""}${
                        Number.isInteger(payload[0].value) === true ? payload[0].value : payload[0].value.toFixed(2)
                    }`}{" "}
                    (
                    {totalValue === 0
                        ? "0"
                        : Number.isInteger((payload[0].value / totalValue) * 100) === true
                          ? (payload[0].value / totalValue) * 100
                          : ((payload[0].value / totalValue) * 100).toFixed(2)}
                    %)
                </div>
            </div>
        );
    }

    return null;
}
